import { getMessage } from "../../Utilities/messageApi";

export const handleApiResponse = (
  response,
  onSuccess,
  onFailure,
  config = {}
) => {
  const message = getMessage();
  const { showMessage = true, showFailed = true, customMessage = "" } = config;
  const { status, data } = response || {};
  const msg = customMessage || data?.message || "";

  if (status >= 200 && status < 300 && data?.success) {
    if (onSuccess) onSuccess(data?.data);
  } else {
    if (onFailure) onFailure?.(data);
  }
};

const displayedErrors = new Set();

export const handleAxiosError = (
  error,
  fallbackMessage = "Unknown error",
  type = "error"
) => {
  const message = getMessage();
  if (!error) return;

  const key = `${error?.code || ""}|${error?.config?.url || ""}`;
  if (displayedErrors.has(key)) return;

  let msg = fallbackMessage;
  if (error.response?.data?.message) msg = error.response.data.message;
  else if (error.message) msg = error.message;

  if (!["success", "error", "warning", "info", "loading"].includes(type)) {
    type = "error";
  }
  message[type](msg);
  displayedErrors.add(key);
  setTimeout(() => displayedErrors.delete(key), 4000);
};
